// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2meOs","insightsList":"newBusinessInsightsMenu_insightsList__1W5Rz","active":"newBusinessInsightsMenu_active__1PKLn"};